<template>
    <main id="teinte">
        <section id="teinteDesktop">
            <div id="Teinte" class="rel">
                <section id="productsModule" :class="relatedProducts()" v-if="this.$route.name === 'Module'">
                    <section id="ticketStrips">
                        <h2 id="title" class="txtCenter ff-medium rel">
                            TICKET STRIPS
                            <button
                                id="edit"
                                class="btn abs pointer mobileNot ff-light uppercase"
                                @click="addStripsItems"
                                v-if="
                                    (getDetails(this.$route.params.id).type === 'product' && hasAccessUpdate('product_manager')) ||
                                        (getDetails(this.$route.params.id).type === 'module' && hasAccessUpdate('module_manager'))
                                "
                            >
                                {{ $t("product.ticket") }}
                            </button>
                        </h2>
                        <div id="imgTicket" v-for="(n, index) in findRelatedTicketsStrip" :key="n.big">
                            <img
                                class="block center fleft shadesPosition flexContainer fw-w mobileNot pointer"
                                :src="getImgPathFig(n.figures.big, 'big')"
                                :id="'smallPhoto' + n.figures.big"
                                width="50%"
                                @click="openTicket(n.id);"
                            />
                        </div>
                        <div class="clear"></div>
                        <p class="link"></p>
                    </section>
                </section>
            </div>
        </section>
        <ModalStrips
            v-if="showModalStrips"
            :itemType="itemType"
            :stripsItem="stripsItem"
            @closeModal="modalClose($event);"
            @relatedItemSaved="addedItem($event);"
        ></ModalStrips>
    </main>
</template>

<script>
import { mapGetters } from "vuex";
import Globals from "../globals.js";
import ModalStrips from "../modal/modalStrips";
import cacheService from "@/services/cache";

export default {
    data: () => ({
        product: {},
        showModalStrips: false,
        swiperOption: {
            direction: "horizontal",
            loop: true,
            grabCursor: true,
            setWrapperSize: true,
            autoHeight: false,
            pagination: ".swiper-pagination",
            prevButton: ".swiper-button-prev",
            nextButton: ".swiper-button-next",
            paginationClickable: true,
            mousewheelControl: true,
            observeParents: true,
            debugger: true,
            slidesPerView: 6
        },
        rollIndex: null,
        rollIndex2: null,
        rollIndex3: null
    }),
    components: {
        ModalStrips
    },
    watch: {},
    methods: {
        openTicket(id) {
            this.$router.push("/artwork/" + id);
            location.reload();
        },
        modalClose(close) {
            this.showModalStrips = close;
        },
        addStripsItems() {
            this.showModalStrips = true;
            this.stripsItem = true;
        },
        getImgPathFig(imgPath, format) {
            return Globals.getBaseUrl() + imgPath;
        },
        toModuleProduct(id, type) {
            if (type === "product") {
                this.$router.push("/product/" + id);
                location.reload();
            } else if (type === "module") {
                this.$router.push("/module/" + id);
                location.reload();
            }
        },
        onHoverModule(index) {
            this.rollIndex2 = index;
        },
        bordered(index) {
            return (index + 1) % 6 ? "bordered" : "";
        },
        row(index) {
            return index + 1 <= 6 ? "firstRow" : "secondRow";
        },
        itemClassModule(index) {
            return this.bordered(index) + " " + this.row(index);
        },
        hover(index) {
            if (this.rollIndex === index || this.rollIndex2 === index || this.rollIndex3 === index) {
                return "hover-parent";
            }
            if (this.rollIndex === index + 1 || this.rollIndex2 === index + 1 || this.rollIndex3 === index + 1) {
                return "hover-parent";
            } else {
                return "";
            }
        },
        displayFolModules() {
            if (this.getRelModulesLength <= 6) {
                this.swiperOption.loop = false;
                this.swiperOption.grabCursor = false;
            } else {
                this.swiperOption.loop = true;
                this.swiperOption.grabCursor = true;
            }
        },
        onHoverLeave() {
            this.rollIndex = null;
            this.rollIndex2 = null;
            this.rollIndex3 = null;
        },
        onHoverRelProduct(index) {
            this.rollIndex3 = index;
        },
        getImgPath(imgPath, format) {
            return Globals.getBaseUrl() + imgPath;
        },
        relatedProducts() {
            if (this.getRelProductsLength <= 6) {
                this.swiperOption.loop = false;
                this.swiperOption.grabCursor = false;
            } else {
                this.swiperOption.loop = true;
                this.swiperOption.grabCursor = true;
            }
        },
        updateRelatedModules() {
            this.moduleRelated = this.getRelatedModules(this.$route.params.id);
            for (let i in this.moduleRelated) {
                if (this.moduleRelated[i].infosArticle.client_ref1 === undefined) {
                    this.keyExist = false;
                } else if (this.moduleRelated[i].infosArticle.client_ref1 !== undefined) {
                    this.keyExist = true;
                }
            }
        },
        updateRelatedProduct() {
            this.product = this.getRelatedProducts(this.$route.params.id);
        }
    },
    computed: {
        ...mapGetters({
            getDetails: "items/getDetails",
            findRelatedTicketsStrip: "items/findRelatedTicketsStrip"
        })
    },
    created() {
        this.$store.dispatch("items/findRelatedTicketsStrip", { id: this.$route.params.id }).then(() => {});
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";

.shadesPosition {
    margin-left: 63px;
    margin-top: 10px;
}
#teinte {
    @extend %second-bloc;
    @extend %second-text;
    margin-right: 30px;
    margin-left: 30px;
    #teinteDesktop {
        #title {
            font-size: 18px;
            margin-top: 30px;
        }
        #edit {
            font-size: 1.4rem;
            right: 0;
            top: -7px;
            margin-right: 50px;
        }
    }
}
#otherProducts,
#productsModule {
    padding: 30px;
    ul {
        padding: 0;
        margin-bottom: 40px;
        li {
            list-style: none;
            font-size: 1.6rem;
            padding-bottom: 0.4rem;
            color: #95989a;
            font-weight: 300;
            border-bottom: 1px solid #f4f4f4;
            z-index: 3;
            &:hover {
                cursor: pointer;
                color: #343434;
                transition: all 0.3s;
            }
            &:first-child {
                padding-right: 10px;
            }
            &:nth-child(3) {
                padding-left: 10px;
            }
        }
        &:after {
            content: "";
            height: 1px;
            display: block;
            width: 100%;
            background: #eee;
            position: absolute;
            top: 23px;
            z-index: 2;
        }
    }
    .slideContent {
        p {
            font-size: 1.4rem;
        }
        .ff-bold {
            margin-top: 10px;
            margin-bottom: 5px;
        }
        .ff-light {
            margin-top: 0;
        }
        &:hover {
            .name {
                color: transparent;
            }
        }
    }
    .active {
        border-bottom: 2px solid #343434;
        color: #343434;
        font-weight: 500;
        transition: all 0.2s;
    }
    .roll-over {
        background: rgba(255, 255, 255, 0.9);
        color: #343434;
        border-radius: 5px;
        font-size: 1.4rem;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        div {
            max-width: 230px;
            display: block;
            margin: auto;
            padding-top: 15px;
        }
        .btn-hover {
            bottom: 0px;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        p {
            margin: 5px 0;
        }
        h4 {
            margin-bottom: 5px;
        }
        .btn {
            background: transparent;
            border-radius: 2em;
            border: 1px solid #343434;
            padding: 0.65em 1.7em;
            font-size: 1.4rem;
            cursor: pointer;
            margin-bottom: 10px;
            &-dark {
                background: #343434;
                color: #fff;
                border: 1px solid #343434;
            }
        }
        figure {
            height: 200px;
            img {
                max-width: 100%;
                height: inherit;
            }
        }
        h3 {
            font-size: 1.8rem;
        }
        .slide-fade-enter-active {
            transition: all 0.3s ease;
        }
        .slide-fade-leave-active {
            transition: all 0.2s cubic-bezier(1, 0.5, 0.5, 1);
        }
        .slide-fade-enter,
        .slide-fade-leave-to {
            transform: translateY(10px);
            opacity: 0;
        }
        #relatedItems {
            max-width: 300px;
            margin-left: 30px;
            margin-bottom: 30px;
        }
        .swiper-container-horizontal {
            .swiper-pagination {
                margin-top: 10px;
                position: initial;
            }
        }
    }
}
@media only screen and (max-width: 767px) {
    .linkToItem {
        height: 100%;
        // background: red;
        z-index: 50;
        #figure {
            img {
                height: auto;
            }
        }
    }
    .relModule {
        margin-left: 20px;
        margin-right: 20px;
    }
    .swiper-pagination {
        margin-bottom: 10px;
        position: initial;
    }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
    .linkToItem {
        height: 100%;
        // background: red;
        z-index: 50;
        #figure {
            img {
                height: auto;
            }
        }
    }
    .relModule {
        margin-left: 30px;
        margin-right: 30px;
    }
    .swiper-pagination {
        margin-bottom: 10px;
        position: initial;
    }
}
</style>



// WEBPACK FOOTER //
// TicketStrip.vue?0d291040